import { CurrencyEnum, PaymentPlans } from "@finway-group/shared/lib/models"

export const paymentPlan: PaymentPlans = {
    monthly: 10,
    yearly: 120,
    currency: CurrencyEnum.EUR,
} as PaymentPlans
